/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

export type V1ProjectsDeleteProjectRequestBody = {
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  project: string;
};

/** @internal */
export type V1ProjectsDeleteProjectRequestBody$Outbound = {
  project: string;
};

/** @internal */
export const V1ProjectsDeleteProjectRequestBody$outboundSchema: z.ZodType<
  V1ProjectsDeleteProjectRequestBody$Outbound,
  z.ZodTypeDef,
  V1ProjectsDeleteProjectRequestBody
> = z.object({
  project: z.string(),
});

export function v1ProjectsDeleteProjectRequestBodyToJSON(
  v1ProjectsDeleteProjectRequestBody: V1ProjectsDeleteProjectRequestBody,
): string {
  return JSON.stringify(
    V1ProjectsDeleteProjectRequestBody$outboundSchema.parse(
      v1ProjectsDeleteProjectRequestBody,
    ),
  );
}
